import React, { useState } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    Typography,
    Button,
    IconButton,
    TextField,
    Paper,
    Box,
    Stack,
} from "@mui/material";
import { toast } from "react-toastify";
import CloseIcon from "@mui/icons-material/Close";
import { useDispatch, useSelector } from "react-redux";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import { postWhitelistDomainSlice } from "../../../redux/actions/postWhitelistDomainSlice";
import { postWhitelistDomainEndpoint } from "../../../common/endpoints";

const WhitelistDomainModal = ({
    open,
    handleClose,
    domains,
    onSubmit,
}) => {

    const [reason, setReason] = useState("Business Purpose. These are the domains which will be whitelisted and allowed to access Supplier forecast Collaboration application");
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const loggedInUser = localStorage.getItem("userEmail");

    const submit = async () => {

        try {
            setLoading(true);

            const payload = {
                domains: domains.map((d) => d.domain),
                user: loggedInUser, // replace with auth user
                justification: reason,
            };

            const response = await dispatch(
                postWhitelistDomainSlice({
                    dynamicEndpoint: postWhitelistDomainEndpoint,
                    data: payload,
                })
            );

            if (response?.meta?.requestStatus === "fulfilled") {

                const result = response?.payload;

                const acceptedDomains = result?.acceptedDomains || [];
                const invalidDomains = result?.invalidDomains || [];

                let toastMessage = result?.message || "Request submitted successfully.";

                if (acceptedDomains.length > 0) {
                    toastMessage += `\n\nAccepted Domains:\n${acceptedDomains.join(", ")}`;
                }

                if (invalidDomains.length > 0) {
                    toastMessage += `\n\nInvalid Domains:\n${invalidDomains.join(", ")}`;
                }

                toast.success(toastMessage, {
                    autoClose: 7000,
                });

                if (onSubmit) {
                    onSubmit(result);
                }

                setReason("");
                handleClose();

            } else {
                toast.error("Failed to submit whitelist request.");
            }

        } catch (error) {
            console.error("Whitelist API error:", error);
            toast.error("Something went wrong.");
        } finally {
            setLoading(false);
            handleClose()
        }
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            maxWidth="sm"
            fullWidth
        >

            <DialogTitle
                sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                Whitelist Domains

                <IconButton onClick={handleClose}>
                    <CloseIcon />
                </IconButton>

            </DialogTitle>

            <DialogContent>

                <Typography
                    color="text.secondary"
                    mb={2}
                >
                    The following domains have been selected for whitelisting. Provide a business justification and submit
                </Typography>

                <Typography
                    variant="subtitle2"
                    sx={{
                        mb: 1,
                        fontWeight: 700,
                    }}
                >
                    SELECTED DOMAINS ({domains.length})
                </Typography>

                <Paper
                    variant="outlined"
                >

                    {
                        domains.map((item) => (

                            <Stack
                                key={item.domain}
                                direction="row"
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{
                                    px: 2,
                                    py: 1.5,
                                    borderBottom: "1px solid #eee"
                                }}
                            >

                                <Stack
                                    direction="row"
                                    spacing={1}
                                    alignItems="center"
                                >

                                    <CheckCircleOutlineIcon
                                        color="success"
                                        fontSize="small"
                                    />

                                    <Typography
                                        fontWeight={600}
                                    >
                                        {item.domain}
                                    </Typography>

                                </Stack>

                                <Typography
                                    variant="caption"
                                    color="text.secondary"
                                >
                                    {item.requestDate}
                                </Typography>

                            </Stack>

                        ))
                    }

                </Paper>

                <Box mt={3}>

                    <Typography
                        fontWeight={600}
                        mb={1}
                    >
                        Business Justification *
                    </Typography>

                    <TextField
                        fullWidth
                        multiline
                        rows={4}
                        value={reason}
                        onChange={(e) => setReason(e.target.value)}
                        placeholder="Provide business reason for whitelisting..."
                    />

                    <Typography
                        variant="caption"
                        color="text.secondary"
                    >
                        {reason.length} characters
                    </Typography>

                </Box>

            </DialogContent>

            <DialogActions>
                <Button
                    onClick={handleClose}
                    sx={{
                        color: "#616161",
                        "&:hover": {
                            backgroundColor: "transparent",
                            color: "#616161",
                        },
                    }}
                >
                    Cancel
                </Button>

                <Button
                    variant="contained"
                    disabled={!reason.trim() || loading}
                    onClick={submit}
                    sx={{
                        backgroundColor: "#000",
                        color: "#fff",
                        textTransform: "none",
                        "&:hover": {
                            backgroundColor: "#000",
                            color: "#fff",
                            boxShadow: "none",
                        },
                    }}
                >
                    {loading ? 'Submitting' : 'Submit'}
                </Button>

            </DialogActions>

        </Dialog>
    );
};

export default WhitelistDomainModal;